import { useState, useEffect, useRef, useCallback } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { Box, Button, Drawer, IconButton, List, Typography } from "@mui/material";
import { DashboardSidebarItem } from "./dashboard-sidebar-item";
import { Scrollbar } from "./scrollbar";
import { ChevronLeft as ChevronLeftIcon } from "../icons/chevron-left";
import { ChevronRight as ChevronRightIcon } from "../icons/chevron-right";
import BusinessIcon from "@mui/icons-material/Business";
import GroupsIcon from "@mui/icons-material/Groups";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import ListAltIcon from "@mui/icons-material/ListAlt";
import { useAuth } from "../hooks/use-auth";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import Person4Icon from "@mui/icons-material/Person4";
import PaymentsIcon from "@mui/icons-material/Payments";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import DescriptionIcon from "@mui/icons-material/Description";
import PaymentIcon from "@mui/icons-material/Payment";
import SettingsIcon from "@mui/icons-material/Settings";
import DashboardIcon from "@mui/icons-material/Dashboard";

import {
  Category,
  CurrencyExchange,
  Inventory,
  LocalAtm,
  Storefront,
  AddHomeWork,
  Receipt,
  BrandingWatermark,
  ReceiptLong,
  PriceCheckSharp,
  MonetizationOn,
  Logout as LogoutIcon
} from "@mui/icons-material";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PublicIcon from "@mui/icons-material/Public";
import ImportExportIcon from '@mui/icons-material/ImportExport';
import AssessmentIcon from "@mui/icons-material/Assessment";
import GavelIcon from "@mui/icons-material/Gavel";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
// const items = [
//   {
//     icon: GroupsIcon,
//     title: "Employees",
//     href: "/dashboard/employees",
//   },
//   {
//     icon: PublicIcon,
//     title: "Departments",
//     href: "/dashboard/department",
//   },
//   {
//     icon: SubscriptionsIcon,
//     title: "Subscriptions",
//     href: "/dashboard/subscriptions",
//   },
//   // {
//   //   icon: BusinessIcon,
//   //   title: 'Brands',
//   //   href: '/dashboard/brands',
//   // },
//   // {
//   //   icon: BusinessIcon,
//   //   title: "Business Accounts",
//   //   href: "/dashboard/business-heads",
//   // },
//     {
//     icon: BusinessIcon,
//     title: "Organization",
//     href: "/dashboard/organization",
//   },
//   {
//     icon: CurrencyRupeeIcon,
//     title: "Tax Accounts",
//     href: "/dashboard/taxaccounts",
//   },
//   {
//     icon: AttachMoneyIcon,
//     title: "Tax Schemes",
//     href: "/dashboard/taxcode",
//   },
//   {
//     icon: PaymentsIcon,
//     title: "Payment Channels",
//     href: "/dashboard/paymentchannels",
//   },
//   {
//     icon: PaymentIcon,
//     title: "Payment Profile",
//     href: "/dashboard/paymentprofile",
//   },
//   {
//     icon: GroupsIcon,
//     title: "Clients",
//     href: "/dashboard/clients",
//   },
//   {
//     icon: MonetizationOn,
//     title: "Currencies",
//     href: "/dashboard/currencies",
//   },
//    {
//     icon: PublicIcon,
//     title: "Country",
//     href: "/dashboard/country",
//   },

//   {
//     icon: PriceChangeIcon,
//     title: "Transactions",
//     href: "/dashboard/transactions",
//   },
//   {
//     icon: PriceCheckSharp,
//     title: "Transaction Category",
//     href: "/dashboard/transaction-category",
//   },
//   {
//     icon: DescriptionIcon,
//     title: "Business Invoices",
//     href: "/dashboard/business-invoices",
//   },
//   {
//     icon: DescriptionIcon,
//     title: "Business Invoices2",
//     href: "/dashboard/business-invoices2",
//   },
//   {
//     icon: CurrencyExchange,
//     title: "Reimbursement",
//     href: "/dashboard/reimbursement",
//   },
//   {
//     icon: Storefront,
//     title: "Vendors",
//     href: "/dashboard/vendors",
//   },
//   {
//     icon: LocalAtm,
//     title: "Vendors Payment",
//     href: "/dashboard/vendorpayment",
//   },
//   {
//     icon: ReceiptOutlinedIcon,
//     title: "Vendor Bills",
//     href: "/dashboard/vendor-bills",
//   },
//   {
//     icon: ReceiptLong,
//     title: "Vendor Category",
//     href: "/dashboard/vendor-category",
//   },
//   {
//     icon: Inventory,
//     title: "Inventory",
//     href: "/dashboard/inventory",
//   },
//   {
//     icon: Category,
//     title: "Inventory Category",
//     href: "/dashboard/category",
//   },
//   {
//     icon: BrandingWatermark,
//     title: "Inventory Brands",
//     href: "/dashboard/brands",
//   },
//   {
//     icon: AddHomeWork,
//     title: "Work Orders",
//     href: "/dashboard/work-orders",
//   },
//   {
//     icon: AccountBalanceWalletIcon,
//     title: "Ledger",
//     href: "/dashboard/ledger",
//   },
//   {
//     icon: PriceChangeIcon,
//     title: "Internal Invoice",
//     href: "/dashboard/internal-invoice",
//   },

// ];
// ✅ Reordered menu items according to requested order
const items = [
  // 1. Dashboard
  {
    icon: DashboardIcon,
    title: "Dashboard",
    href: "/dashboard/main",
  },
  // 2. Clients
  { icon: GroupsIcon, title: "Clients", href: "/dashboard/clients" },
  // 3. Transactions
  {
    icon: PriceChangeIcon,
    title: "Transactions",
    href: "/dashboard/transactions",
  },
  // 4. Invoices
  {
    icon: DescriptionIcon,
    title: "Invoices",
    href: "/dashboard/business-invoices",
  },
  // 5. Quotations
  {
    icon: RequestQuoteIcon,
    title: "Quotations",
    href: "/dashboard/quotations",
  },
  // 6. Follow Ups
  {
    icon: FactCheckOutlinedIcon,
    title: "Follow Ups",
    href: "/dashboard/follow-ups",
  },
  // 6. Bills
  {
    icon: ReceiptOutlinedIcon,
    title: "Bills",
    href: "/dashboard/bills",
  },
  {
    icon: DescriptionIcon,
    title: "Bill Copies",
    href: "/dashboard/bill-copies",
  },
  // 6. Ledger
  {
    icon: AccountBalanceWalletIcon,
    title: "Ledger",
    href: "/dashboard/ledger",
  },
  // 7. Pay Requests
  { icon: PaymentsIcon, title: "Pay Requests", href: "/dashboard/pay-request" },
  // 8. Payment Profiles
  {
    icon: PaymentIcon,
    title: "Payment Profiles",
    href: "/dashboard/masterdata/paymentprofile",
  },
  // 9. Notes
  { icon: DescriptionIcon, title: "Notes", href: "/dashboard/client-notes" },
  // 10. Tasks
  { icon: FactCheckOutlinedIcon, title: "Accounting Tasks", href: "/dashboard/accounting-tasks" },

  // Remaining Items
  {
    icon: Receipt,
    title: "Credit Notes",
    href: "/dashboard/credit-notes",
  },
  // Tax Returns collapsible section
  {
    icon: AssessmentIcon,
    title: "Tax Returns",
    items: [
      {
        icon: ListAltIcon,
        title: "Tax Returns",
        href: "/dashboard/tax-returns",
      },
      {
        icon: DescriptionIcon,
        title: "Invoices",
        href: "/dashboard/tax-returns/invoices",
      },
      {
        icon: ReceiptOutlinedIcon,
        title: "GSTR-2B",
        href: "/dashboard/gstr2b",
      },
    ],
  },
  // Tax collapsible section
  {
    icon: GavelIcon,
    title: "Tax",
    items: [
      {
        icon: CurrencyRupeeIcon,
        title: "TDS",
        href: "/dashboard/tax/tds",
      },
    ],
  },
  { icon: AddHomeWork, title: "Work Orders", href: "/dashboard/work-orders" },
  {
    icon: CurrencyExchange,
    title: "Reimbursement",
    href: "/dashboard/reimbursement",
  },
  {
    icon: Storefront,
    title: "Vendors",
    href: "/dashboard/vendors",
  },
  { icon: Storefront, title: "Purchase Orders", href: "/dashboard/purchase-orders" },
  {
    icon: SubscriptionsIcon,
    title: "Subscriptions",
    href: "/dashboard/subscriptions",
  },
  { icon: GroupsIcon, title: "Employees", href: "/dashboard/employees" },
  {
    icon: Person4Icon,
    title: "Users",
    href: "/dashboard/users",
  },

  // Master Data collapsible section
  {
    icon: BusinessIcon,
    title: "Master Data",
    items: [
      {
        icon: BusinessIcon,
        title: "Organizations",
        href: "/dashboard/masterdata/organization",
      },
      {
        icon: CurrencyRupeeIcon,
        title: "Tax Accounts",
        href: "/dashboard/masterdata/taxaccounts",
      },
      {
        icon: PaymentsIcon,
        title: "Payment Channels",
        href: "/dashboard/masterdata/paymentchannels",
      },
      {
        icon: AttachMoneyIcon,
        title: "Tax Scheme",
        href: "/dashboard/masterdata/taxscheme",
      },
      {
        icon: FactCheckOutlinedIcon,
        title: "Tax Codes",
        href: "/dashboard/masterdata/taxcode",
      },
      {
        icon: PublicIcon,
        title: "Countries",
        href: "/dashboard/masterdata/country",
      },
      {
        icon: MonetizationOn,
        title: "Currencies",
        href: "/dashboard/masterdata/currencies",
      },

      {

        icon: SettingsIcon,
        title: "Settings",
        href: "/dashboard/masterdata/settings",
      },
      {
        icon: PriceCheckSharp,
        title: "Transaction Categories",
        href: "/dashboard/masterdata/transaction-category",
      },
      {
        icon: ReceiptLong,
        title: "Vendor Categories",
        href: "/dashboard/masterdata/vendor-category",
      },
      {
        icon: Category,
        title: "Inventory Categories",
        href: "/dashboard/masterdata/category",
      },
      {
        icon: BrandingWatermark,
        title: "Inventory Brands",
        href: "/dashboard/masterdata/brands",
      },
      // Adding Financial Years to Master Data menu
      {
        icon: BusinessIcon,
        title: "Financial Years",
        href: "/dashboard/masterdata/financial-years",
      },
      {
        icon: ImportExportIcon,
        title: "Import Formats",
        href: "/dashboard/masterdata/import-formats",
      },
      {
        icon: BusinessIcon,
        title: "Business Verticals",
        href: "/dashboard/masterdata/business-verticals",
      },
    ],
  },
];

export const DashboardSidebar = (props) => {
  const { onPin, pinned, mobileOpen, onMobileClose } = props;
  const [openedItem, setOpenedItem] = useState(null);
  const [hovered, setHovered] = useState(false);
  const hoverTimeout = useRef(null);
  const location = useLocation();
  const auth = useAuth();

  const handleMouseEnter = useCallback(() => {
    if (!onMobileClose) {
      hoverTimeout.current = setTimeout(() => setHovered(true), 200);
    }
  }, [onMobileClose]);

  const handleMouseLeave = useCallback(() => {
    clearTimeout(hoverTimeout.current);
    if (!onMobileClose) setHovered(false);
  }, [onMobileClose]);

  useEffect(() => {
    return () => clearTimeout(hoverTimeout.current);
  }, []);

  const handleOpenItem = (item) => {
    if (openedItem === item) {
      setOpenedItem(null);
      return;
    }

    setOpenedItem(item);
  };

  // Auto-open parent if a child is active
  useEffect(() => {
    items.forEach((item) => {
      if (item.items) {
        const isChildActive = item.items.some((subItem) => location.pathname === subItem.href);
        if (isChildActive) {
          setOpenedItem(item);
        }
      }
    });
  }, [location.pathname]);

  const logoutHandler = () => {
    auth.logout();
  };

  return (
    <Drawer
      anchor="left"
      onClose={onMobileClose}
      open={onMobileClose ? mobileOpen : true}
      sx={{ zIndex: (theme) => theme.zIndex.appBar + 100 }}
      variant={onMobileClose ? "temporary" : "permanent"}
      PaperProps={{
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        sx: {
          backgroundColor: "background.paper",
          height: "100%",
          overflowX: "hidden",
          transition: "width 250ms cubic-bezier(0.4, 0, 0.2, 1)",
          width: (onMobileClose || pinned || hovered) ? 250 : 73,
          borderRight: (theme) => `1px solid ${theme.palette.divider}`,
          "& .simplebar-content": {
            height: "100%",
          },
        },
      }}
    >
      <Scrollbar
        sx={{
          height: '100%',
          '& .simplebar-content': {
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          }
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              p: 2,
              borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
              minHeight: 64,
              overflow: "hidden",
              whiteSpace: "nowrap"
            }}
          >
            <Box
              component="img"
              src="https://www.spiderworks.in/theme/web/img/logo-sw.png" // Placeholder for logo
              alt=""
              sx={{
                height: 32,
                width: 32,
                objectFit: "cover",
                borderRadius: 1,
                backgroundColor: "grey.300",
                mr: 2,
                flexShrink: 0
              }}
            />
            {(hovered || pinned) && (
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 700,
                  color: "text.primary",
                  fontSize: "0.875rem",
                  letterSpacing: "0.5px",
                  textTransform: "uppercase"
                }}
              >
                Accounts Portal
              </Typography>
            )}
          </Box>

          <Box sx={{ flexGrow: 1, overflowY: "auto", px: 2, py: 1 }}>
            <List
              disablePadding
              sx={{ scrollbarWidth: "none" }}
            >
              {items.map((item) => {
                const active = item.href ? location.pathname === item.href : false;

                return (
                  <DashboardSidebarItem
                    key={item.title}
                    onOpen={() => handleOpenItem(item)}
                    open={openedItem?.title === item.title && (hovered || pinned)}
                    pinned={pinned || hovered}
                    active={active}
                    location={location}
                    iconColor="black"
                    {...item}
                  />
                );
              })}
            </List>
          </Box>

          <Box
            sx={{
              p: 2,
              borderTop: (theme) => `1px solid ${theme.palette.divider}`,
              display: "flex",
              flexDirection: "column",
              gap: 1
            }}
          >
            <Button
              fullWidth
              onClick={logoutHandler}
              variant="outlined"
              size="small"
              color="inherit"
              sx={{
                justifyContent: "center",
                minWidth: 0,
                px: (hovered || pinned) ? 2 : 0,
                border: (hovered || pinned) ? undefined : 'none',
                "& .MuiButton-startIcon": {
                  margin: (hovered || pinned) ? undefined : 0
                }
              }}
              startIcon={<LogoutIcon fontSize="small" />}
            >
              {(hovered || pinned) && "Logout"}
            </Button>

            <Box sx={{ display: 'flex', justifyContent: (hovered || pinned) ? 'flex-end' : 'center' }}>
              <IconButton onClick={onPin} size="small">
                {pinned ? <ChevronLeftIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
              </IconButton>
            </Box>
          </Box>
        </Box>
      </Scrollbar>
    </Drawer>
  );
};

DashboardSidebar.propTypes = {
  onPin: PropTypes.func,
  pinned: PropTypes.bool,
};

// { icon: DescriptionIcon, title: "Business Invoices2", href: "/dashboard/business-invoices2" },
// { icon: Storefront, title: "Vendors", href: "/dashboard/vendors" },
// { icon: LocalAtm, title: "Vendors Payment", href: "/dashboard/vendorpayment" },
// { icon: ReceiptOutlinedIcon, title: "Vendor Bills", href: "/dashboard/vendor-bills" },
// { icon: Inventory, title: "Inventory", href: "/dashboard/inventory" },
// { icon: PriceChangeIcon, title: "Internal Invoice", href: "/dashboard/internal-invoice" },
// { icon: PublicIcon, title: "Departments", href: "/dashboard/department" },
//  { icon: DescriptionIcon, title: "Business Invoices", href: "/dashboard/business-invoices" },
